// strategies/ExecutiveSummaryStrategy.js
import ChatStrategy from './ChatStrategy';

export default class ExecutiveSummaryStrategy extends ChatStrategy {
  constructor() {
    super();
    this.retryMessages = [
      'Reattempting to generate the executive summary. Please hold on.',
      'Initiating a new request for the executive summary.',
      'The process will be restarted. Generating the executive summary now.',
      'A new attempt is in progress to provide the requested summary.',
      'Reprocessing the data to generate the executive summary.',
      'Please wait while I regenerate the summary based on the latest inputs.',
      'Retrying the summary generation to ensure accurate results.',
      'The system is preparing a fresh version of the executive summary.',
      'Starting a new attempt to generate the required summary.',
      'Generating the executive summary once again. Thank you for your patience.',
    ];
    this.type = 'executive_summary';
  }

  // eslint-disable-next-line no-unused-vars
  getIdentity(metadata) {
    return 'executive_summary';
  }

  getStrategyTitle() {
    return 'Repair Select - Executive Summary';
  }

  createPayload(chatId, metadata, interactions) {
    const sanitize = (v) => {
      if (typeof v !== 'string') return v;

      // Remove HTML tags
      let cleaned = v.replace(/<[^>]*>/g, '');

      // Decode common HTML entities
      cleaned = cleaned
        .replace(/&amp;/g, '&')
        .replace(/&lt;/g, '<')
        .replace(/&gt;/g, '>')
        .replace(/&quot;/g, '"')
        // eslint-disable-next-line quotes
        .replace(/&#39;/g, "'")
        .replace(/&nbsp;/g, ' ');

      // Remove quotes
      cleaned = cleaned.replace(/'/g, '').replace(/\\"/g, '').replace(/"/g, '');

      return cleaned;
    };

    const {
      repairAssessment,
      serialNumber,
      model,
      originalOEMNumber,
      customerInfoText,
      workOrderName,
    } = metadata;

    const ratData = (repairAssessment || []).map((r) => ({
      assembly: sanitize(r.assembly || ''),
      clientReject: r.clientReject || false,
      dim: sanitize(r.dim || ''),
      estimatedLabor: sanitize(r.estimatedLabor || ''),
      id: sanitize(r.id || ''),
      itemNumber: Math.ceil(
        isNaN(Number(r.itemNumber)) ? 0 : Number(r.itemNumber)
      ),
      level: r.level || 0,
      missing: r.missing || 0,
      ndt: sanitize(r.ndt || ''),
      partName: sanitize(r.partName || ''),
      partNumber: sanitize(r.partNumber || ''),
      quantity: r.quantity || 0,
      received: r.received || 0,
      repair: r.repair || 0,
      repairScope: sanitize(r.repairScope || ''),
      replace: r.replace || 0,
      reuse: r.reuse || 0,
      reviewed: r.reviewed || false,
      summary: sanitize(r.summary || ''),
      visual: sanitize(r.visual || ''),
    }));

    return {
      providedId: chatId,
      requestType: 'executive_summary',
      serialNumber,
      model: model.map((m) => sanitize(m.text)),
      oem: [sanitize(originalOEMNumber)],
      customer: sanitize(customerInfoText),
      productLine: workOrderName.map((productLine) =>
        sanitize(productLine.text)
      ),
      ratData,
      interactionData: interactions,
    };
  }

  parseUserMessage() {
    const idx = Math.floor(Math.random() * this.retryMessages.length);
    return this.retryMessages[idx];
  }

  onMessageReceived(event) {
    if (event.status_code === 500) {
      return {
        text: 'An error has occurred. Please try again later.',
        isError: true,
      };
    }

    return {
      text: event.result,
      isError: false,
    };
  }
}
